import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2, 2),
    textAlign: 'center',
    background:'transparent',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    minHeight: '200px',
    transition: 'all 0.3s ease-in-out', 
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
      background:'transparent',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5, 2),
    },
  },
  content: {
    maxWidth: '1090px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop:theme.spacing(1.3), 
    paddingRight: theme.spacing(3), 
    paddingLeft:theme.spacing(3), 
    paddingBottom:theme.spacing(3), 
    backdropFilter: 'blur(2px)',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    color: theme.palette.text.nonary,
    fontFamily: 'Montserrat',
    fontSize: '60px',
    fontWeight: 700,
    letterSpacing: '-1px',
    marginBottom: '16px',
     paddingTop: 0,
    margin: 0, 
    lineHeight: 1, 

    [theme.breakpoints.down('sm')]: {
      fontSize: '48px',
    },
  },
  titleGreen: {
        fontFamily: 'Montserrat',
    color: '#06E89F',
    // textShadow: '0 2px 4px rgba(6, 232, 159, 0.3)',
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: '20px', 
    fontWeight: 500,
    lineHeight: '1.5', 
    textAlign: 'left',
     color: theme.palette.text.secondary,
    maxWidth: '900px', 
    width: '100%',
    margin: '0',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      letterSpacing: '-0.2px',
    },
  },
  textBold: {
    fontWeight: 700,
     color: theme.palette.text.tertiary,
  },
}));

export default useStyles;